module.exports = __webpack_public_path__ + "img/ai.0891577a.svg";